import React from 'react';
import PropTypes from 'prop-types';

const countries = require('i18n-iso-countries');

import classes from './Address.scss';
// import SimplGoogleMap from '../SimplGoogleMap/SimplGoogleMap';
// import 'apple-mapkit-js';
import { AppleMaps } from 'react-apple-mapkitjs';

const brIfExists = data => {
  if (
    typeof data !== 'undefined' &&
    data &&
    data !== 'null null' &&
    data !== 'undefined undefined' &&
    data.length
  ) {
    // TODO: re enable secondData again
    // if (typeof secondData !== 'undefined' && secondData && secondData.length) {
    //   data = `${data} ${secondData}`;
    // }

    return (
      <span>
        {data}
        <br />
      </span>
    );
  }

  return null;
};

export const Address = props => {
  let addressString = `${props.address.street}, ${props.address.zip} ${
    props.address.city
  }, ${props.address.province}, ${countries.getName(
    props.address.country,
    'de',
  )}`;

  if (typeof props.address.street === 'undefined') {
    return <div />;
  }

  let map = null;

  // eslint-disable-next-line no-console
  console.log(props.address.latLong);

  if (
    typeof props.address.latLong !== 'undefined' &&
    props.address.latLong.lat !== 0
  ) {
    // map = (
    //   <SimplGoogleMap
    //     lat={props.address.latLong.lat}
    //     long={props.address.latLong.long}
    //   />
    // );

    // Apple Maps Package has a problem with lat and long, they are mixed up
    // https://github.com/tonyduanesmith/react-apple-mapkitjs/pull/7

    map = (
      <AppleMaps
        token={window.appleMapsToken}
        longitude={props.address.latLong.long}
        latitude={props.address.latLong.lat}
        // longitude={props.address.latLong.lat}
        // latitude={props.address.latLong.long}
        zoomLevel={16}
        height="400px"
        width="400px"
      />
    );
    // map = ();
  }

  let cityline = '';
  if (props.address.zip !== null) {
    cityline = props.address.zip;
  }
  if (props.address.city !== null) {
    cityline = `${cityline} ${props.address.city}`;
  }

  return (
    <div className="row">
      <div className="col-xs-12 col-md-6">
        <a
          href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
            addressString,
          )}`}
          target="_blank"
          className={classes.address}
        >
          {brIfExists(props.address.street)}
          {brIfExists(props.address.extra_address_line)}
          {brIfExists(`${cityline}`)}
          {brIfExists(props.address.province)}
          {countries.getName(props.address.country, 'de')}
        </a>
      </div>
      <div className={`col-xs-12 col-md-6 ${classes.map}`}>{map}</div>
    </div>
  );
};

Address.propTypes = {
  address: PropTypes.object.isRequired,
};

Address.defaultProps = {
  address: {},
};

export default Address;



// WEBPACK FOOTER //
// ./src/components/Address/Address.js